import { Box, type BoxProps } from "@mui/material";
import type { FC } from "react";
import type { CommsImageLoaderState } from "./generate-comms-context";
import Lottie from "lottie-light-react";
import star from "./../content-previews/star.json";

export const CommsTemplateCarouselImage: FC<
  BoxProps & { selected?: boolean; image?: CommsImageLoaderState }
> = ({ image, selected = false, sx = [], ...props }) => (
  <Box
    data-analytics-id="template-carousel-image"
    sx={[
      (theme) => ({
        boxSizing: "content-box",
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: selected ? theme.palette.primary.main : "divider",
        cursor: props.onClick ? "pointer" : "default",
        backgroundImage:
          image && !image?.loading && image.data?.url ? `url(${image.data.url})` : "none",
        backgroundSize: "cover",
        position: "relative",
        "&:hover": {
          borderColor: theme.palette.primary.main,
        },
        borderRadius: "8px",
      }),
      ...(sx instanceof Array ? sx : [sx]),
    ]}
    boxShadow={2}
    role="button"
    {...props}
  >
    {(!image || image?.loading || !image.data) && (
      <Box
        style={{
          display: "flex",
          marginTop: "8px",
          marginLeft: "8px",
        }}
      >
        <Lottie animationData={star} loop autoPlay style={{ width: "24px", height: "24px" }} />
      </Box>
    )}
  </Box>
);
